import * as AccordionPrimitives from "@radix-ui/react-accordion";
import classNames from "classnames";
import { Content, ItemGrid } from "components/DesignSystem/Accordion/Accordion";
import { InfoItem } from "components/DesignSystem/InfoItem/InfoItem";
import React, { ReactNode } from "react";

export const Trigger = ({
  children,

  ...props
}: {
  children: ReactNode;
} & AccordionPrimitives.AccordionTriggerProps &
  React.RefAttributes<HTMLButtonElement>) => {
  return (
    <AccordionPrimitives.Trigger asChild {...props}>
      <button className="all:unset t-group t-select-none t-text-subtext after:t-content-[''] after:t-block after:t-absolute after:t-bottom-0 after:t-w-[calc(100%-32px)] after:t-mx-4 after:t-right-0 t-w-full t-capitalize t-block">
        {children}
      </button>
    </AccordionPrimitives.Trigger>
  );
};

export const Item = (
  props: AccordionPrimitives.AccordionItemProps &
    React.RefAttributes<HTMLDivElement> & {
      isActive?: boolean;
      isLastItem?: boolean;
      propClass?: string;
    }
) => {
  return (
    <AccordionPrimitives.Item
      {...props}
      className={classNames(
        `t-border t-border-solid t-border-l-0 t-border-t-0 t-border-r-0 t-pb-4 ${
          props.propClass || ""
        }`,
        {
          "t-animate-active": props.isActive,
          "t-border-neutral-10": !props.isActive,
          "t-border-b-0": props.isLastItem,
        }
      )}
      data-state="open"
    />
  );
};

export const CustomTaxOthersAccordion = {
  ...AccordionPrimitives,
  Item,
  Trigger,
  Content,
  ItemGrid,
  InfoItem,
};
